import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { initLocalDevTenantContext } from './services/devTenantContext';
import App from './App';
import { ToastProvider } from './components/UI/ToastProvider';

initLocalDevTenantContext();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <>
    <ToastProvider>
      <App />
    </ToastProvider>
  </>
);
